import {useCallback, useEffect, useMemo, useState} from 'react';

import styled from 'styled-components';
import {useSelector} from 'react-redux';

import {media} from '~/shared/theme/media';
import {MoneyCard} from '~/shared/services/bffService/api/interfaces/responses';
import {usePersonalAreaContext} from '~/personalArea/context';
import TenbisCardsList from '~/personalArea/components/Sections/MyTenbis/TenbisCardsList';
import {selectUserData} from '~/shared/store/storeModules/user';

import TenbisCardView from './TenbisCardView';
import useMyTenbisActions from './useMyTenbisActions';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 24px;
  ${media.minLargeTablet`
    padding: 40px;
  `}
`;

const MyTenbis = () => {
  const [currentMoneycard, setCurrentMoneycard] = useState<MoneyCard | null>(null);
  const {isMoneyCardsLoading, moneycards: allCards} = usePersonalAreaContext();
  const userData = useSelector(selectUserData);

  const onMoneycardClick = useCallback((moneycard: MoneyCard) => {
    setCurrentMoneycard(moneycard);
  }, []);

  const onBackButtonClick = useCallback(() => setCurrentMoneycard(null), []);

  const moneycards = useMemo(() => allCards?.filter(moneycard => !moneycard.isTenbisCredit) || [], [allCards]);

  const actions = useMyTenbisActions();

  useEffect(() => {
    if (currentMoneycard === null && !isMoneyCardsLoading && moneycards?.length === 1) {
      setCurrentMoneycard(moneycards[0]);
    }
  }, [isMoneyCardsLoading, moneycards, currentMoneycard]);

  return (
    <Root>
      {currentMoneycard !== null && (
        <TenbisCardView
          moneycard={currentMoneycard}
          onBackButtonClick={moneycards.length > 1 ? onBackButtonClick : null}
          userData={userData}
          actions={actions}
        />
      )}
      {currentMoneycard === null && !!moneycards && moneycards.length && (
        <TenbisCardsList
          moneycards={moneycards}
          onMoneycardClick={onMoneycardClick}
        />
      )}
    </Root>
  );
};

export default MyTenbis;
